import type { ComponentProps } from "./projects-link.d";
import "./projects-link.scss";

import React, { useEffect, useState } from "react";

import { useAppStore } from "../../../react4xp/shared/stores";

function Component(props: ComponentProps) {
	const { tabsType, group, items } = props;
	const visibleItemsCount = 3;

	const appStore = useAppStore((state) => state);
	const [groupedItems, setGroupedItems] = useState<Record<string, ComponentProps["items"]["hits"]> | null>(null);

	useEffect(() => {
		if (items.hits.length > 0) {
			setGroupedItems(
				items.hits.reduce((acc = {}, item) => {
					const key = item.data.category;
					acc[key] ??= [];
					acc[key].push(item);
					return acc;
				}, {})
			);
		}
	}, [items]);

	return (
		<section className={`link link-${group}`}>
			<div className={`d-md-flex gap-4 ${tabsType === "vertical" ? "" : "flex-column"}`}>
				{groupedItems && (
					<>
						<img src={appStore.imageLinks?.decor} alt="decor img" className="decor" />
						<div className="tab-content w-100" id={`link-${group}-tabContent`}>
							{Object.entries(groupedItems).map(([, items], i) => (
								<div
									key={`link-${group}-content-${i}`}
									className={`tab-pane fade w-100 h-100 ${i === 0 ? "show active" : ""}`}
									id={`link-${group}-content-${i}`}
								>
									<div className="project-responsive-grid">
										{items.map(({ _id, displayName, data: { contentTypeImage, contentTypeImageAltText, link } }, j) => (
											<div key={_id} className="project-responsive-grid-item card border-0 shadow-sm">
												<a href={link} className={`btn flex-row ${j + 1 > visibleItemsCount ? "d-none" : ""}`}>
													<div className="card-body d-flex flex-column gap-3">
														<h5 className="card-title d-flex flex-wrap flex-md-nowrap align-items-center gap-3 text-start">
															{contentTypeImage && (
																<img src={contentTypeImage} alt={contentTypeImageAltText} loading="lazy" />
															)}
															{displayName}
														</h5>
													</div>
												</a>
											</div>
										))}
									</div>
									<div className="d-flex align-items-center justify-content-center w-100 mt-3">
										<a
											href={`${appStore.sitePath?.[0].link}/${items[0].data.categoryLink}?category=${items[0].data.categoryId}`}
											className="btn btn-primary d-flex align-items-center gap-3 justify-content-between text-uppercase"
										>
											{appStore.phrases?.["showAll"] || "Показать все"}
											<span className="line"></span>
											<i className="fa-solid fa-arrow-right"></i>
										</a>
									</div>
								</div>
							))}
						</div>
					</>
				)}

				{!groupedItems && (
					<div className="empty">
						<h3>{appStore.phrases?.["empty"]}</h3>
					</div>
				)}
			</div>
		</section>
	);
}

export default function WrappedComponent(props: ComponentProps) {
	return <Component {...props} />;
}
